const { types, referenceTypes, uiTypes } = require("../utils/types");
const { validatorTypes } = require("../utils/validatorTypes");

// Filter chips on the Deals section ("Verified Distress", "NRI Exit Block", ...)
const obj = {
  tableName: "deal_categories",
  read: true,
  create: true,
  edit: true,
  delete: true,
  comments: false,
  references: [],
  columns: [
    {
      name: "id",
      type: types.UUID,
      allowNull: false,
      defaultValue: types.UUIDV4,
      primaryKey: true,
      validation: [validatorTypes.uuid, validatorTypes.optional],
      ui: {
        type: uiTypes.TEXT,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "name",
      type: types.STRING,
      validation: [validatorTypes.string, validatorTypes.required],
      ui: {
        type: uiTypes.TEXT,
        validation: [validatorTypes.string, validatorTypes.required],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "priority",
      type: types.INTEGER,
      allowNull: true,
      validation: [validatorTypes.isInteger, validatorTypes.optional],
      ui: {
        type: uiTypes.NUMBER,
        validation: [],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "enabled",
      type: types.BOOLEAN,
      defaultValue: true,
      validation: [validatorTypes.bool, validatorTypes.optional],
      ui: {
        type: uiTypes.SWITCH,
        validation: [],
        list: true,
        read: true,
        create: true,
        edit: true,
      },
    },
    {
      name: "createdAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        type: uiTypes.DATE,
        validation: [],
        list: true,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "updatedAt",
      type: types.DATE,
      allowNull: false,
      defaultValue: null,
      ui: {
        type: uiTypes.DATE,
        validation: [],
        list: false,
        read: true,
        create: false,
        edit: false,
      },
    },
    {
      name: "deletedAt",
      type: types.DATE,
      allowNull: true,
      defaultValue: null,
      read: false,
      ui: {
        type: uiTypes.TEXT,
        validation: [],
        list: false,
        read: false,
        create: false,
        edit: false,
      },
    },
  ],
};
module.exports = obj;
